import React from 'react'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import { makeStyles } from '@material-ui/core/styles'
import { Theme, Link } from '@material-ui/core'
import { ConfiguratorProductDetails } from '../../../Configurators/products/ConfiguratorSharedTypes'

import DownloadIcon from '@src/icons/DownloadIcon'
import getConfig from 'next/config'

const {
  publicRuntimeConfig: { featureFlags },
} = getConfig()
const useStyles = makeStyles((theme: Theme) => {
  return {
    multiProductTemplateIcon: {
      color: theme.palette.primary.main,
      marginBottom: theme.spacing(-0.5),
      marginRight: theme.spacing(1),
    },
    multiProductTemplateText: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.primary.main,
      marginLeft: theme.spacing(1),
      marginBottom: 1,
    },
    multiProductTemplateButton: {
      padding: 2,
      borderRadius: 0,
      '&:hover': {
        background: 'none',
        textDecoration: 'underline',
      },
    },
  }
})

interface DownloadsItem {
  label: React.ReactNode
  isPCR: boolean
  productType?: string
}

interface DownloadsItemProps {
  items: DownloadsItem
  productDetails: ConfiguratorProductDetails
}

const DownloadTemplate: React.FC<DownloadsItemProps> = ({
  items,
  productDetails,
}) => {
  const classes = useStyles()
  const url = `/configurator-upload/bulk-entry/template/${
    items.productType || productDetails.productType
  }/${productDetails.countryCode}?isCSR=${
    productDetails.isCSR
  }&isCSRSupervisor=${productDetails.isCSRSupervisor}&isPCR=${items.isPCR}
  `

  return (
    <div>
      <Link href={url} className={classes.multiProductTemplateButton} download>
        {featureFlags.internalAndDualQuenchProbes ? (
          <DownloadIcon className={classes.multiProductTemplateIcon} />
        ) : (
          <CloudDownloadIcon className={classes.multiProductTemplateIcon} />
        )}
        <span className={classes.multiProductTemplateText}>{items.label}</span>
      </Link>
    </div>
  )
}

export default DownloadTemplate
